// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"350":"ff428fc7","368":"524461e1","800":"9a027551","884":"8196a8a7","924":"2be671b7"}[chunkId] + ".css";
};